// AoT requires an exported function for factories
import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../../environments/environment';

export function HttpLoaderFactory(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
        // host app i18n assets
        {
            prefix: `${environment.everestApiUrl}/translations/v2/projects/daae8a6956d574b1552b935daf85ab8d/download?locale=`,
            suffix: '&format=simple_json'
        },
        // question flow lib assets
        {
            prefix: `${environment.everestApiUrl}/translations/v2/projects/5cfb7f9a03a8d6fba82d29aa840b7715/download?locale=`,
            suffix: '&format=simple_json'
        },
        // dsw lib assets
        {
            prefix: `${environment.everestApiUrl}/translations/v2/projects/ec38b083a23c58c604a49d7f443dd7f2/download?locale=`,
            suffix: '&format=simple_json'
        },
        // ca components assets
        {
            prefix: `${environment.everestApiUrl}/translations/v2/projects/31fb8c95c8f4afd6c68b63a48b96116b/download?locale=`,
            suffix: '&format=simple_json'
        }
    ]);
}
